import { Controller } from '@hotwired/stimulus';

// Controller for studio autocomplete with auto-submit on selection
// Used in booking process step 1 (shooting selection)
export default class extends Controller {
  selectStudio(event) {
    const select = event.currentTarget;
    const studioId = select.value;

    if (studioId) {
      // Auto-submit the form when a studio is selected
      const form = select.closest('form');
      if (form) {
        form.requestSubmit();
      }
    }
  }
}
